// src/helpers/fetchQuestionnaires.js



import { getDatabase, ref, get } from "firebase/database";

/**
 * Fetch all questionnaires for a specific listing/property.
 * @param {string} listingId - The unique ID of the listing/property.
 * @returns {Promise<Array>} - Array of {requestId, questionnaire, ...requestMeta}
 */
const fetchQuestionnaires = async (listingId) => {
  if (!listingId) {
    console.log("[fetchQuestionnaires] No listingId provided:", listingId);
    throw new Error("Listing ID is required.");
  }
  try {
    const database = getDatabase();
    const viewingRequestsRef = ref(database, `listings/${listingId}/viewingRequests`);
    console.log(
      `[fetchQuestionnaires] Fetching questionnaires for listingId: ${listingId}`,
      "| path:", `listings/${listingId}/viewingRequests`
    );
    const snapshot = await get(viewingRequestsRef);
    if (!snapshot.exists()) {
      console.log(`[fetchQuestionnaires] No viewing requests found for listingId ${listingId}`);
      return [];
    }
    const requests = snapshot.val();
    // Turn {requestId: {request data}} into [{...requestData, requestId}]
    const questionnaires = Object.entries(requests)
      .filter(([_, req]) => req.questionnaire && Object.keys(req.questionnaire).length > 0)
      .map(([requestId, req]) => ({
        requestId,
        questionnaire: req.questionnaire,
        ...req, // include any other data if you want (like name/email)
      }));
    console.log(
      `[fetchQuestionnaires] Fetched ${questionnaires.length} questionnaires for listingId ${listingId}`,
      questionnaires
    );
    return questionnaires;
  } catch (error) {
    console.error("Error fetching questionnaires:", error);
    throw error;
  }
};

export default fetchQuestionnaires;

// import { getDatabase, ref, get } from "firebase/database";

// /**
//  * Fetch all questionnaires for a specific listing/property.
//  * @param {string} listingId - The unique ID of the listing/property.
//  * @returns {Promise<Object>} - Object of questionnaires or empty object.
//  */
// const fetchQuestionnaires = async (listingId) => {
//   if (!listingId) {
//     console.log("[fetchQuestionnaires] No listingId provided:", listingId);
//     throw new Error("Listing ID is required.");
//   }
//   try {
//     const database = getDatabase();
//     const questionnairesRef = ref(database, `listings/${listingId}/questionnaires`);
//     console.log(
//       `[fetchQuestionnaires] Fetching questionnaires for listingId: ${listingId}`,
//       "| path:", `listings/${listingId}/questionnaires`
//     );
//     const snapshot = await get(questionnairesRef);
//     console.log(
//       `[fetchQuestionnaires] Firebase snapshot for listingId ${listingId}:`,
//       snapshot.exists(),
//       snapshot.val()
//     );
//     if (snapshot.exists()) {
//       console.log(
//         `[fetchQuestionnaires] Questionnaires data found for listingId ${listingId}:`,
//         snapshot.val()
//       );
//       return snapshot.val(); // Returns object: { viewingRequestId: { questionnaireData } }
//     }
//     console.log(`[fetchQuestionnaires] No questionnaires found for listingId ${listingId}`);
//     return {};
//   } catch (error) {
//     console.error("Error fetching questionnaires:", error);
//     throw error;
//   }
// };

// export default fetchQuestionnaires;

